import site_logo from '../Assets/Icon/Logo.png';
import site_logo_dark from '../Assets/Icon/Logo.png';
import depositINR_qrcode from '../Assets/Image/qrcode.png';
// import nexusPdf from '../Assets/Image/nexus.pdf';
import nexusPDF from '../Assets/Image/nexus.pdf';

export const logo = site_logo;
export const dark_logo = site_logo_dark;
export const title = 'NEXUS TRADEZZ';
export const websiteName = 'NEXUS TRADEZZ';
export const shortTitle = 'NEXUS TRADEZZ';
export const titleDescription = 'NEXUS TRADEZZ';
export const Image_path = site_logo;
export const des_upi = "yespay123@payts.com";
export const pdfFile = nexusPDF;

export const qrcode = depositINR_qrcode;

// export const website = 'http://techidea.store/';
export const website = 'https://nexustradezz.in/';

// export const api_url = 'http://97.107.130.111:8001/api/v1/';
export const api_url = 'https://api.nexustradezz.in/api/v1/';

// export const api_url = 'http://192.168.43.155:8001/api/v1/';    
// export const api_url = 'http://localhost:8001/api/v1/';

// export const api_url = 'http://192.168.18.39:8001/api/v1/'; 





